import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  es: {
    // Login
    login: 'Iniciar Sesión',
    userId: 'Usuario',
    password: 'Contraseña',
    loginButton: 'Ingresar',
    loginError: 'Error de autenticación',
    welcomeBack: 'Bienvenido de nuevo',
    enterCredentials: 'Ingrese sus credenciales para continuar',
    
    // Dashboard
    dashboard: 'Panel de Control',
    newsManagement: 'Noticias',
    addNews: 'Agregar Noticia',
    editNews: 'Editar Noticia',
    deleteNews: 'Eliminar',
    confirmDelete: '¿Está seguro de eliminar esta noticia?',
    cancel: 'Cancelar',
    save: 'Guardar',
    saving: 'Guardando...',
    logout: 'Cerrar Sesión',
    
    // News Form
    spanishContent: 'Contenido en Español',
    englishContent: 'Contenido en Inglés',
    badge: 'Etiqueta',
    title: 'Título',
    subtitle: 'Subtítulo',
    frequency: 'Frecuencia',
    description: 'Descripción',
    publishedAt: 'Fecha de Publicación',
    backgroundImage: 'Imagen de Fondo',
    portraitImage: 'Imagen de Perfil',
    uploadImage: 'Subir Imagen',
    dragDropImage: 'Arrastra una imagen o haz clic para seleccionar',
    maxFileSize: 'Tamaño máximo: 2MB',
    
    // News List
    newsList: 'Lista de Noticias',
    noNews: 'No hay noticias registradas',
    actions: 'Acciones',
    edit: 'Editar',
    view: 'Ver',
    created: 'Creado',
    
    // Messages
    newsCreated: 'Noticia creada exitosamente',
    newsUpdated: 'Noticia actualizada exitosamente',
    newsDeleted: 'Noticia eliminada exitosamente',
    imageUploaded: 'Imagen subida exitosamente',
    errorOccurred: 'Ha ocurrido un error',
    fileTooLarge: 'El archivo excede el límite de 2MB',
    invalidFileType: 'Tipo de archivo no válido',
    
    // General
    loading: 'Cargando...',
    search: 'Buscar',
    all: 'Todos',
    back: 'Volver',
  },
  en: {
    // Login
    login: 'Login',
    userId: 'User ID',
    password: 'Password',
    loginButton: 'Sign In',
    loginError: 'Authentication error',
    welcomeBack: 'Welcome back',
    enterCredentials: 'Enter your credentials to continue',
    
    // Dashboard
    dashboard: 'Dashboard',
    newsManagement: 'News Management',
    addNews: 'Add News',
    editNews: 'Edit News',
    deleteNews: 'Delete',
    confirmDelete: 'Are you sure you want to delete this news item?',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
    logout: 'Logout',
    
    // News Form
    spanishContent: 'Spanish Content',
    englishContent: 'English Content',
    badge: 'Badge',
    title: 'Title',
    subtitle: 'Subtitle',
    frequency: 'Frequency',
    description: 'Description',
    publishedAt: 'Published At',
    backgroundImage: 'Background Image',
    portraitImage: 'Portrait Image',
    uploadImage: 'Upload Image',
    dragDropImage: 'Drag an image or click to select',
    maxFileSize: 'Max file size: 2MB',
    
    // News List
    newsList: 'News List',
    noNews: 'No news items registered',
    actions: 'Actions',
    edit: 'Edit',
    view: 'View',
    created: 'Created',
    
    // Messages
    newsCreated: 'News item created successfully',
    newsUpdated: 'News item updated successfully',
    newsDeleted: 'News item deleted successfully',
    imageUploaded: 'Image uploaded successfully',
    errorOccurred: 'An error occurred',
    fileTooLarge: 'File exceeds 2MB limit',
    invalidFileType: 'Invalid file type',
    
    // General
    loading: 'Loading...',
    search: 'Search',
    all: 'All',
    back: 'Back',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('aercaribe_language') || 'es';
  });

  useEffect(() => {
    localStorage.setItem('aercaribe_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
